module.exports = __webpack_public_path__ + "static/media/gfk-logo.ca714db1.jpg";